<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.8333 11.6682V16.6682C10.8333 17.1266 11.2083 17.5016 11.6667 17.5016H16.6667C17.125 17.5016 17.5 17.1266 17.5 16.6682V11.6682C17.5 11.2099 17.125 10.8349 16.6667 10.8349H11.6667C11.2083 10.8349 10.8333 11.2099 10.8333 11.6682ZM3.33333 17.5016H8.33333C8.79167 17.5016 9.16667 17.1266 9.16667 16.6682V11.6682C9.16667 11.2099 8.79167 10.8349 8.33333 10.8349H3.33333C2.875 10.8349 2.5 11.2099 2.5 11.6682V16.6682C2.5 17.1266 2.875 17.5016 3.33333 17.5016ZM2.5 3.3349V8.3349C2.5 8.79323 2.875 9.16823 3.33333 9.16823H8.33333C8.79167 9.16823 9.16667 8.79323 9.16667 8.3349V3.3349C9.16667 2.87656 8.79167 2.50156 8.33333 2.50156H3.33333C2.875 2.50156 2.5 2.87656 2.5 3.3349ZM13.2917 2.00156L9.75 5.5349C9.425 5.8599 9.425 6.3849 9.75 6.7099L13.2917 10.2516C13.6167 10.5766 14.1417 10.5766 14.4667 10.2516L18.0083 6.7099C18.3333 6.3849 18.3333 5.8599 18.0083 5.5349L14.475 2.00156C14.15 1.67656 13.6167 1.67656 13.2917 2.00156Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
